/**
 * Superbundle variant selector — PDP + Quick Buy.
 *
 * Liquid still renders `.superbundle-selector` with data-* config.
 * This file binds the Regular/Bundle switch, fly-bundle ATC, and qty UI.
 * Quick Buy calls `window.PWSuperbundle.initIn(modal)` after morph because
 * inline scripts inside fetched PDP HTML do not execute.
 */
(function () {
  function isQuickBuyContext(el) {
    return !!(el && el.closest && el.closest('#quick-add-modal-content, quick-add-dialog, .quick-add-modal'));
  }

  function getRoot(selector) {
    return (
      selector.closest('#quick-add-modal-content, quick-add-dialog, [data-product-grid-content], .product-information') ||
      document
    );
  }

  function findSelectorFor(fromEl) {
    if (fromEl && fromEl.closest) {
      var own = fromEl.closest('.superbundle-selector');
      if (own) return own;
      var scopedRoot = fromEl.closest('#quick-add-modal-content, quick-add-dialog, [data-product-grid-content], .shopify-section');
      if (scopedRoot) {
        var scoped = scopedRoot.querySelector('.superbundle-selector');
        if (scoped) return scoped;
      }
    }
    var modal = document.getElementById('quick-add-modal-content');
    var dialogOpen = document.querySelector('quick-add-dialog dialog[open]');
    if (dialogOpen && modal) {
      var inModal = modal.querySelector('.superbundle-selector');
      if (inModal) return inModal;
    }
    return document.querySelector('.superbundle-selector');
  }

  window.__superbundleSwitchTo = function (mode, fromEl) {
    var selector = findSelectorFor(fromEl);
    if (selector && typeof selector.__sbSwitchTo === 'function') {
      selector.__sbSwitchTo(mode);
    }
  };

  function initSelector(selector) {
    if (!selector || selector.dataset.sbInited === 'true') return;

    var root = getRoot(selector);
    var isQuickBuy = isQuickBuyContext(selector);
    var isFlyParent = selector.classList.contains('superbundle-fly-parent');

    /* Fly-parent markup exists on PDP too; only bind ATC inside Quick Buy. */
    if (isFlyParent && !isQuickBuy) return;

    selector.dataset.sbInited = 'true';

    /* Isolate modal radios from a PDP instance of the same name. */
    if (isQuickBuy && !isFlyParent) {
      selector.querySelectorAll('input[name="superbundle-option"]').forEach(function (radio) {
        radio.name = 'superbundle-option-qv';
      });
    }

    /* When combined with linked_products, place Superbundle after linked pills on one row */
    if (!isFlyParent && selector.classList.contains('superbundle-selector--with-linked')) {
      var alreadyWrapped = selector.parentElement && selector.parentElement.classList.contains('linked-with-superbundle');
      if (!alreadyWrapped) {
        var linkedRow = root.querySelector('[data-linked-main-variants]');
        if (linkedRow && linkedRow.parentNode) {
          var wrap = document.createElement('div');
          wrap.className = 'linked-with-superbundle';
          linkedRow.parentNode.insertBefore(wrap, linkedRow);
          wrap.appendChild(linkedRow);
          wrap.appendChild(selector);
        }
      }
    }

    var buyBlock = root.querySelector('.buy-buttons-main-container .buy-buttons-block') || root.querySelector('.buy-buttons-block');
    var buyContainer = root.querySelector('.buy-buttons-main-container');
    var stickyBar = isQuickBuy ? null : document.querySelector('product-sticky-bar');
    var bundleWrap = null;
    var atcSection = null;
    var qtySection = null;
    var bundleAtcBtn = null;
    var qtyInput = null;
    var deleteIcon = null;
    var minusIcon = null;

    var stickyDesktopForm = stickyBar ? stickyBar.querySelector('.product-sticky-bar__desktop product-form-component') : null;
    var stickyMobileForm = stickyBar ? stickyBar.querySelector('.product-sticky-bar__mobile product-form-component') : null;
    var stickyBundleUI = { desktop: null, mobile: null };

    var prices = {
      regular: { price: parseInt(selector.dataset.regularPrice, 10), compare: parseInt(selector.dataset.regularComparePrice, 10) },
      bundle: { price: parseInt(selector.dataset.bundlePrice, 10), compare: parseInt(selector.dataset.bundleComparePrice, 10) }
    };

    var bundleFlyIds = selector.dataset.bundleFlyIds;
    var bundleOfferId = selector.dataset.bundleOfferId;
    var bundleName = selector.dataset.bundleName || '';
    var bundleDigitalMapRaw = selector.dataset.bundleDigitalMap || null;
    var bundleHandle = selector.dataset.bundleHandle;
    var bundleLineProps = {};
    try {
      bundleLineProps = JSON.parse(selector.dataset.bundleLineProps || '{}');
    } catch (e) {
      bundleLineProps = {};
    }

    function findBundleParentItem(cart, offerIdKeyed) {
      var items = (cart && cart.items) || [];
      return (
        items.find(function (item) {
          var props = item.properties || {};
          return props.OfferId === offerIdKeyed || props['_flyBundles:OfferId'] === offerIdKeyed;
        }) || null
      );
    }

    function applySuperbundleLineProps(offerIdKeyed, attempt) {
      if (!bundleLineProps || !Object.keys(bundleLineProps).length) {
        return Promise.resolve();
      }
      var tryCount = attempt || 0;
      return fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var parent = findBundleParentItem(cart, offerIdKeyed);
          if (!parent || !parent.key) {
            if (tryCount < 2) {
              return new Promise(function (resolve) {
                setTimeout(function () {
                  resolve(applySuperbundleLineProps(offerIdKeyed, tryCount + 1));
                }, 300);
              });
            }
            return null;
          }
          var merged = Object.assign({}, parent.properties || {}, bundleLineProps);
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: parent.key,
              quantity: parent.quantity,
              properties: merged
            })
          });
        })
        .catch(function (err) {
          console.error('Superbundle line props error:', err);
        });
    }

    var titleEl = root.querySelector('.product-title-share-title') || root.querySelector('.view-product-title a, .product-header a');
    var regularTitle = selector.dataset.regularTitle;
    var bundleTitle = selector.dataset.bundleTitle;

    var originalGalleryNode = null;
    var bundleGalleryNode = null;
    var isBundleGallery = false;
    var galleryFetching = false;
    var pendingBundleSwap = false;

    var bundleQty = 0;
    var bundleItemKeys = [];
    var isCartBusy = false;

    function formatPrice(paise) {
      var rupees = Math.floor(paise / 100);
      return '\u20B9 ' + rupees.toLocaleString('en-IN');
    }

    function syncBundleStateFromCart() {
      if (!bundleOfferId) return;
      fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var groups = {};
          var order = [];
          for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            var props = item.properties || {};
            var offerProp = props['_flyBundles:OfferId'] || props['OfferId'];
            if (!offerProp || offerProp.indexOf(bundleOfferId + '_') !== 0) continue;
            if (!groups[offerProp]) {
              groups[offerProp] = [];
              order.push(offerProp);
            }
            groups[offerProp].push(item.key);
          }
          bundleQty = order.length;
          bundleItemKeys = order.map(function (id) {
            return groups[id];
          });
          refreshQtyUI();
        })
        .catch(function () {});
    }

    if (bundleHandle) {
      galleryFetching = true;
      fetch('/products/' + bundleHandle)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var bg = doc.querySelector('media-gallery');
          if (bg) bundleGalleryNode = document.adoptNode(bg);
          galleryFetching = false;
          if (pendingBundleSwap) {
            pendingBundleSwap = false;
            doGallerySwap();
          }
        })
        .catch(function () {
          galleryFetching = false;
        });
    }

    function doGallerySwap() {
      var gallery = root.querySelector('media-gallery');
      if (!gallery || !bundleGalleryNode) return;
      originalGalleryNode = gallery;
      gallery.replaceWith(bundleGalleryNode);
      isBundleGallery = true;
    }

    function createBundleUI() {
      var w = document.createElement('div');
      w.className = 'superbundle-atc-wrapper';
      w.style.display = 'none';
      w.innerHTML =
        '<div class="superbundle-atc-section">' +
          '<div class="product-form-buttons">' +
            '<span class="add-to-cart-button-wrapper">' +
              '<button type="button" class="button button--primary superbundle-atc-btn">' +
                '<span aria-hidden="true" class="add-to-cart-text--added"><span>' +
                  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15.7505 10.5V6C15.7505 3.92893 14.0716 2.25 12.0005 2.25C9.92942 2.25 8.25048 3.92893 8.25048 6V10.5M19.6065 8.50723L20.8697 20.5072C20.9396 21.1715 20.4188 21.75 19.7508 21.75H4.25012C3.58221 21.75 3.06138 21.1715 3.1313 20.5072L4.39446 8.50723C4.45473 7.93466 4.93755 7.5 5.51328 7.5H18.4877C19.0634 7.5 19.5462 7.93466 19.6065 8.50723ZM8.62548 10.5C8.62548 10.7071 8.45759 10.875 8.25048 10.875C8.04338 10.875 7.87548 10.7071 7.87548 10.5C7.87548 10.2929 8.04338 10.125 8.25048 10.125C8.45759 10.125 8.62548 10.2929 8.62548 10.5ZM16.1255 10.5C16.1255 10.7071 15.9576 10.875 15.7505 10.875C15.5434 10.875 15.3755 10.7071 15.3755 10.5C15.3755 10.2929 15.5434 10.125 15.7505 10.125C15.9576 10.125 16.1255 10.2929 16.1255 10.5Z" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
                '</span></span>' +
                '<span class="add-to-cart-text"><span class="add-to-cart-text__content">Add to Bag</span></span>' +
              '</button>' +
            '</span>' +
          '</div>' +
        '</div>' +
        '<div class="superbundle-qty-section" style="display:none;">' +
          '<div class="product-form-buttons">' +
            '<div class="product-quantity-selector">' +
              '<button type="button" class="button quantity-delete-minus button-unstyled sb-minus-btn">' +
                '<span class="svg-wrapper quantity-icon quantity-icon--delete">' +
                  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.7404 9L14.3942 18M9.60577 18L9.25962 9M19.2276 5.79057C19.5696 5.84221 19.9104 5.89747 20.25 5.95629M19.2276 5.79057L18.1598 19.6726C18.0696 20.8448 17.0921 21.75 15.9164 21.75H8.08357C6.90786 21.75 5.93037 20.8448 5.8402 19.6726L4.77235 5.79057M19.2276 5.79057C18.0812 5.61744 16.9215 5.48485 15.75 5.39432M3.75 5.95629C4.08957 5.89747 4.43037 5.84221 4.77235 5.79057M4.77235 5.79057C5.91878 5.61744 7.07849 5.48485 8.25 5.39432M15.75 5.39432V4.47819C15.75 3.29882 14.8393 2.31423 13.6606 2.27652C13.1092 2.25889 12.5556 2.25 12 2.25C11.4444 2.25 10.8908 2.25889 10.3394 2.27652C9.16065 2.31423 8.25 3.29882 8.25 4.47819V5.39432M15.75 5.39432C14.5126 5.2987 13.262 5.25 12 5.25C10.738 5.25 9.48744 5.2987 8.25 5.39432" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                '</span>' +
                '<span class="svg-wrapper quantity-icon quantity-icon--minus" hidden>' +
                  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                '</span>' +
              '</button>' +
              '<input type="number" value="1" disabled class="sb-qty-input">' +
              '<button type="button" class="button quantity-plus button-unstyled sb-plus-btn">' +
                '<span class="svg-wrapper icon-plus">' +
                  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4.5V19.5M19.5 12L4.5 12" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                '</span>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';

      if (buyContainer) {
        buyContainer.appendChild(w);
      } else if (buyBlock && buyBlock.parentNode) {
        buyBlock.parentNode.appendChild(w);
      } else {
        var form = root.querySelector('product-form-component');
        if (form && form.parentNode) form.parentNode.appendChild(w);
        else root.appendChild(w);
      }

      atcSection = w.querySelector('.superbundle-atc-section');
      qtySection = w.querySelector('.superbundle-qty-section');
      bundleAtcBtn = w.querySelector('.superbundle-atc-btn');
      qtyInput = w.querySelector('.sb-qty-input');
      deleteIcon = w.querySelector('.quantity-icon--delete');
      minusIcon = w.querySelector('.quantity-icon--minus');

      bundleAtcBtn.addEventListener('click', function () {
        addBundleToCart();
      });
      w.querySelector('.sb-plus-btn').addEventListener('click', function () {
        addBundleToCart();
      });
      w.querySelector('.sb-minus-btn').addEventListener('click', handleMinus);

      return w;
    }

    function createStickyBundleUI() {
      if (!stickyBar) return;
      var svgDel =
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.7404 9L14.3942 18M9.60577 18L9.25962 9M19.2276 5.79057C19.5696 5.84221 19.9104 5.89747 20.25 5.95629M19.2276 5.79057L18.1598 19.6726C18.0696 20.8448 17.0921 21.75 15.9164 21.75H8.08357C6.90786 21.75 5.93037 20.8448 5.8402 19.6726L4.77235 5.79057M19.2276 5.79057C18.0812 5.61744 16.9215 5.48485 15.75 5.39432M3.75 5.95629C4.08957 5.89747 4.43037 5.84221 4.77235 5.79057M4.77235 5.79057C5.91878 5.61744 7.07849 5.48485 8.25 5.39432M15.75 5.39432V4.47819C15.75 3.29882 14.8393 2.31423 13.6606 2.27652C13.1092 2.25889 12.5556 2.25 12 2.25C11.4444 2.25 10.8908 2.25889 10.3394 2.27652C9.16065 2.31423 8.25 3.29882 8.25 4.47819V5.39432M15.75 5.39432C14.5126 5.2987 13.262 5.25 12 5.25C10.738 5.25 9.48744 5.2987 8.25 5.39432" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var svgMin =
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var svgPlus =
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4.5V19.5M19.5 12L4.5 12" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      function makeUI(type) {
        var isD = type === 'desktop';
        var atcCls = isD ? 'product-sticky-bar__atc-button' : 'product-sticky-bar__mobile-atc-button';
        var w = document.createElement('div');
        w.className = 'sb-sticky-bundle-wrap';
        w.style.cssText = 'display:none;width:100%;';
        w.innerHTML =
          '<div style="display:flex;align-items:center;gap:12px;width:100%;">' +
            '<span class="sb-sticky-atc-section" style="flex:1;">' +
              '<button type="button" class="button-secondary ' +
              atcCls +
              ' sb-sticky-bundle-atc" style="width:100%;"><span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15.7505 10.5V6C15.7505 3.92893 14.0716 2.25 12.0005 2.25C9.92942 2.25 8.25048 3.92893 8.25048 6V10.5M19.6065 8.50723L20.8697 20.5072C20.9396 21.1715 20.4188 21.75 19.7508 21.75H4.25012C3.58221 21.75 3.06138 21.1715 3.1313 20.5072L4.39446 8.50723C4.45473 7.93466 4.93755 7.5 5.51328 7.5H18.4877C19.0634 7.5 19.5462 7.93466 19.6065 8.50723ZM8.62548 10.5C8.62548 10.7071 8.45759 10.875 8.25048 10.875C8.04338 10.875 7.87548 10.7071 7.87548 10.5C7.87548 10.2929 8.04338 10.125 8.25048 10.125C8.45759 10.125 8.62548 10.2929 8.62548 10.5ZM16.1255 10.5C16.1255 10.7071 15.9576 10.875 15.7505 10.875C15.5434 10.875 15.3755 10.7071 15.3755 10.5C15.3755 10.2929 15.5434 10.125 15.7505 10.125C15.9576 10.125 16.1255 10.2929 16.1255 10.5Z" stroke="#5A4BDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>Add to Bag</button>' +
            '</span>' +
            '<span class="sb-sticky-qty-section" style="display:none;flex:1;">' +
              '<div class="product-quantity-selector" style="width:100%;">' +
                '<button type="button" class="button quantity-delete-minus button-unstyled sb-sticky-minus-btn">' +
                  '<span class="svg-wrapper quantity-icon quantity-icon--delete">' +
                  svgDel +
                  '</span>' +
                  '<span class="svg-wrapper quantity-icon quantity-icon--minus" hidden>' +
                  svgMin +
                  '</span>' +
                '</button>' +
                '<input type="number" value="1" disabled class="sb-sticky-qty-input">' +
                '<button type="button" class="button quantity-plus button-unstyled sb-sticky-plus-btn">' +
                  '<span class="svg-wrapper icon-plus">' +
                  svgPlus +
                  '</span>' +
                '</button>' +
              '</div>' +
            '</span>' +
          '</div>';
        w.querySelector('.sb-sticky-bundle-atc').addEventListener('click', function () {
          addBundleToCart();
        });
        w.querySelector('.sb-sticky-plus-btn').addEventListener('click', function () {
          addBundleToCart();
        });
        w.querySelector('.sb-sticky-minus-btn').addEventListener('click', handleMinus);
        return {
          wrap: w,
          atcSection: w.querySelector('.sb-sticky-atc-section'),
          qtySection: w.querySelector('.sb-sticky-qty-section'),
          atcBtn: w.querySelector('.sb-sticky-bundle-atc'),
          qtyInput: w.querySelector('.sb-sticky-qty-input'),
          deleteIcon: w.querySelector('.quantity-icon--delete'),
          minusIcon: w.querySelector('.quantity-icon--minus')
        };
      }

      var dActions = stickyBar.querySelector('.product-sticky-bar__actions');
      if (dActions) {
        stickyBundleUI.desktop = makeUI('desktop');
        dActions.appendChild(stickyBundleUI.desktop.wrap);
      }
      var mActions = stickyBar.querySelector('.product-sticky-bar__mobile-actions');
      if (mActions) {
        stickyBundleUI.mobile = makeUI('mobile');
        mActions.appendChild(stickyBundleUI.mobile.wrap);
      }
    }

    function fireSuperbundleAddToBagTracking() {
      if (typeof window.addToCartGtm !== 'function') return;
      var productDataFromBundle = null;
      try {
        var rawGtm = selector.dataset.bundleGtm;
        if (rawGtm) productDataFromBundle = JSON.parse(rawGtm);
      } catch (_) {}
      var variantId = selector.dataset.bundleVariantId || null;
      var payload = Object.assign(
        {},
        productDataFromBundle && typeof productDataFromBundle === 'object' ? productDataFromBundle : {},
        {
          product_id: selector.dataset.bundleProductId || null,
          product_variant_id: variantId != null ? String(variantId) : null,
          product_title: selector.dataset.bundleTitle || bundleName || null,
          product_slug: bundleHandle || null,
          total_quantity: 1,
          cta_name: 'add_to_bag',
          triggerElement: bundleAtcBtn || selector
        }
      );
      setTimeout(function () {
        window.addToCartGtm(payload);
      }, 0);
    }

    function addBundleToCart() {
      if (isCartBusy) return;

      var childData;
      try {
        childData = JSON.parse(bundleFlyIds);
      } catch (x) {
        return;
      }

      var digitalMap = null;
      try {
        digitalMap = JSON.parse(bundleDigitalMapRaw || 'null');
      } catch (x) {}

      var rk = Math.random().toString(36).substring(2, 5);
      var offerIdKeyed = bundleOfferId + '_' + rk;

      var items = [];
      var keys = Object.keys(childData);
      for (var k = 0; k < keys.length; k++) {
        var vid = parseInt(childData[keys[k]][0], 10);
        if (!vid) continue;
        var isDigital = digitalMap && digitalMap.hasOwnProperty(String(vid)) ? digitalMap[String(vid)] === true : false;
        items.push({
          id: vid,
          quantity: 1,
          properties: {
            '_flyBundles:OfferId': offerIdKeyed,
            '_flyBundles:prodQty': 1,
            '_flyBundles:customField': bundleName,
            _digital_book: isDigital ? 'true' : 'false',
            _purchase_type: 'null'
          }
        });
      }
      if (!items.length) return;

      isCartBusy = true;
      if (bundleAtcBtn) {
        bundleAtcBtn.classList.add('loading');
        bundleAtcBtn.disabled = true;
      }
      ['desktop', 'mobile'].forEach(function (k) {
        var u = stickyBundleUI[k];
        if (u && u.atcBtn) u.atcBtn.disabled = true;
      });

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'product-form-component', itemCount: 1, isOptimistic: true } }
        })
      );

      fetch('/cart/add.js?app=gfbBundleApp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          bundleQty++;
          isCartBusy = false;
          refreshQtyUI();
          fireSuperbundleAddToBagTracking();
          // Quick Buy: product-form closes via cart:update bubbling from inside the dialog.
          // Superbundle ATC dispatches on document, so close the modal explicitly on success.
          if (isQuickBuy) {
            var dialogComponent = document.getElementById('quick-add-dialog');
            if (dialogComponent && typeof dialogComponent.closeDialog === 'function') {
              dialogComponent.closeDialog();
            }
          }
          return r.text();
        })
        .then(function (text) {
          try {
            var data = JSON.parse(text);
            var addedKeys = [];
            if (data.items) {
              for (var i = 0; i < data.items.length; i++) {
                if (data.items[i].key) addedKeys.push(data.items[i].key);
              }
            }
            bundleItemKeys.push(addedKeys);
          } catch (e) {
            bundleItemKeys.push([]);
          }
          return applySuperbundleLineProps(offerIdKeyed);
        })
        .catch(function (err) {
          console.error('Superbundle ATC error:', err);
          isCartBusy = false;
          if (bundleAtcBtn) {
            bundleAtcBtn.classList.remove('loading');
            bundleAtcBtn.disabled = false;
          }
          ['desktop', 'mobile'].forEach(function (k) {
            var u = stickyBundleUI[k];
            if (u && u.atcBtn) u.atcBtn.disabled = false;
          });
          fetch('/cart.js')
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: { data: { source: 'superbundle-atc', itemCount: cart.item_count } }
                })
              );
            })
            .catch(function () {});
        });
    }

    function handleMinus() {
      if (bundleQty <= 0 || isCartBusy) return;
      isCartBusy = true;

      var keysToRemove = bundleItemKeys.pop();
      if (!keysToRemove || !keysToRemove.length) {
        bundleQty = Math.max(0, bundleQty - 1);
        isCartBusy = false;
        refreshQtyUI();
        return;
      }

      var updates = {};
      for (var i = 0; i < keysToRemove.length; i++) updates[keysToRemove[i]] = 0;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function (cart) {
          bundleQty = Math.max(0, bundleQty - 1);
          isCartBusy = false;
          refreshQtyUI();
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { source: 'superbundle-qty', itemCount: cart.item_count } }
            })
          );
        })
        .catch(function (err) {
          console.error('Superbundle remove error:', err);
          bundleItemKeys.push(keysToRemove);
          isCartBusy = false;
        });
    }

    function refreshQtyUI() {
      /* Quick Buy: keep Add to Bag only — never morph into the qty stepper. */
      if (isQuickBuy) {
        if (qtySection) qtySection.style.display = 'none';
        if (atcSection) atcSection.style.display = '';
        if (bundleAtcBtn) {
          bundleAtcBtn.classList.remove('loading');
          bundleAtcBtn.disabled = false;
        }
        return;
      }

      if (atcSection && qtySection) {
        if (bundleQty > 0) {
          atcSection.style.display = 'none';
          qtySection.style.display = '';
          qtyInput.value = bundleQty;
          deleteIcon.hidden = bundleQty > 1;
          minusIcon.hidden = bundleQty <= 1;
        } else {
          qtySection.style.display = 'none';
          atcSection.style.display = '';
          if (bundleAtcBtn) {
            bundleAtcBtn.classList.remove('loading');
            bundleAtcBtn.disabled = false;
          }
        }
      }
      ['desktop', 'mobile'].forEach(function (k) {
        var ui = stickyBundleUI[k];
        if (!ui) return;
        if (bundleQty > 0) {
          ui.atcSection.style.display = 'none';
          ui.qtySection.style.display = '';
          ui.qtyInput.value = bundleQty;
          ui.deleteIcon.hidden = bundleQty > 1;
          ui.minusIcon.hidden = bundleQty <= 1;
        } else {
          ui.qtySection.style.display = 'none';
          ui.atcSection.style.display = '';
          if (ui.atcBtn) {
            ui.atcBtn.disabled = false;
          }
        }
      });
    }

    function setModalProductPriceHidden(hide) {
      if (!isQuickBuy) return;
      root.querySelectorAll('product-price').forEach(function (el) {
        el.style.display = hide ? 'none' : '';
      });
    }

    function fillQvPriceRow(row, data) {
      var mainEl = row.querySelector('.superbundle-qv-price__sale');
      var compareEl = row.querySelector('.superbundle-qv-price__compare');
      var discountEl = row.querySelector('.superbundle-qv-price__discount');
      var stockEl = row.querySelector('.superbundle-qv-price__stock');
      if (mainEl) mainEl.textContent = formatPrice(data.price);
      var hasCompare = data.compare && data.compare > data.price;
      var pct = hasCompare ? Math.round(((data.compare - data.price) * 100) / data.compare) : 0;
      if (compareEl) {
        compareEl.textContent = hasCompare ? 'MRP ' + formatPrice(data.compare) : '';
        compareEl.style.display = hasCompare ? '' : 'none';
      }
      if (discountEl) {
        discountEl.textContent = hasCompare ? '(' + pct + '% OFF)' : '';
        discountEl.style.display = hasCompare ? '' : 'none';
      }
      if (!stockEl) return;
      if (selector.dataset.bundlePreorder === 'yes') {
        stockEl.textContent = 'Pre-order';
        stockEl.className = 'superbundle-qv-price__stock superbundle-qv-price__stock--in';
        return;
      }
      var inStock = selector.dataset.bundleAvailable !== 'false';
      stockEl.textContent = inStock ? 'In Stock' : 'Out of Stock';
      stockEl.className = 'superbundle-qv-price__stock superbundle-qv-price__stock--' + (inStock ? 'in' : 'out');
    }

    function ensureQvPriceRow() {
      if (!isQuickBuy) return;
      var row = root.querySelector('.superbundle-qv-price');
      if (!row) {
        row = document.createElement('div');
        row.className = 'superbundle-qv-price';
        row.innerHTML =
          '<div class="superbundle-qv-price__row">' +
            '<span class="superbundle-qv-price__sale"></span>' +
            '<span class="superbundle-qv-price__compare"></span>' +
            '<span class="superbundle-qv-price__discount"></span>' +
          '</div>' +
          '<div class="superbundle-qv-price__stock"></div>';
      }
      row.style.setProperty('display', 'flex', 'important');

      // Keep price directly under the title (not inside the ATC wrapper at the bottom).
      var header = root.querySelector('.product-header');
      var titleBlock = root.querySelector('.view-product-title');
      if (header) {
        var titleLink = header.querySelector('a');
        if (row.parentElement !== header || (titleLink && row.previousElementSibling !== titleLink)) {
          if (titleLink && titleLink.nextSibling) {
            header.insertBefore(row, titleLink.nextSibling);
          } else {
            header.appendChild(row);
          }
        }
      } else if (titleBlock && titleBlock.parentNode) {
        if (row.previousElementSibling !== titleBlock) {
          titleBlock.parentNode.insertBefore(row, titleBlock.nextSibling);
        }
      } else if (bundleWrap && row.parentElement !== bundleWrap) {
        bundleWrap.insertBefore(row, bundleWrap.firstChild);
      }

      fillQvPriceRow(row, prices.bundle);
    }

    function hideQvPriceRow() {
      if (!isQuickBuy) return;
      var row = root.querySelector('.superbundle-qv-price');
      if (row) row.style.setProperty('display', 'none', 'important');
    }

    function updatePrice(data) {
      var mainEl = root.querySelector('.main-price-pdp');
      var compareEl = root.querySelector('.compare-at-price-pdp');
      var discountEl = root.querySelector('.discount-pdp');
      var compareGroup = compareEl ? compareEl.closest('.compare-price-pdp') : null;

      if (mainEl) mainEl.textContent = formatPrice(data.price);

      var pct = 0;
      if (data.compare && data.compare > data.price) {
        pct = Math.round(((data.compare - data.price) * 100) / data.compare);
        if (compareEl) compareEl.textContent = formatPrice(data.compare);
        if (compareGroup) compareGroup.style.display = '';
        if (discountEl) {
          discountEl.textContent = '(' + pct + '% OFF)';
          discountEl.style.display = '';
        }
      } else {
        if (compareGroup) compareGroup.style.display = 'none';
        if (discountEl) discountEl.style.display = 'none';
      }

      if (isQuickBuy && window.PWPdpPromo && typeof window.PWPdpPromo.applyWithin === 'function') {
        var promoRaw = root.getAttribute && root.id === 'quick-add-modal-content'
          ? root.getAttribute('data-pw-promo')
          : (root.querySelector('#quick-add-modal-content') || root).getAttribute('data-pw-promo');
        if (!promoRaw && root.getAttribute) promoRaw = root.getAttribute('data-pw-promo');
        if (promoRaw) {
          try {
            window.PWPdpPromo.applyWithin(root, JSON.parse(promoRaw));
          } catch (e) {}
        }
      }

      if (!stickyBar) return;
      var pairs = [
        { p: '.product-sticky-bar__price', c: '.product-sticky-bar__compare-price', d: '.product-sticky-bar__discount' },
        { p: '.product-sticky-bar__mobile-price', c: '.product-sticky-bar__mobile-compare-price', d: '.product-sticky-bar__mobile-discount' }
      ];
      for (var i = 0; i < pairs.length; i++) {
        var sp = stickyBar.querySelector(pairs[i].p);
        var sc = stickyBar.querySelector(pairs[i].c);
        var sd = stickyBar.querySelector(pairs[i].d);
        if (sp) sp.textContent = formatPrice(data.price);
        if (data.compare && data.compare > data.price) {
          if (sc) {
            sc.textContent = formatPrice(data.compare);
            sc.style.display = '';
          }
          if (sd) {
            sd.textContent = '(' + pct + '% OFF)';
            sd.style.display = '';
          }
        } else {
          if (sc) sc.style.display = 'none';
          if (sd) sd.style.display = 'none';
        }
      }
    }

    function swapGallery(mode) {
      if (mode === 'bundle' && !isBundleGallery) {
        if (bundleGalleryNode) {
          doGallerySwap();
        } else if (galleryFetching) {
          pendingBundleSwap = true;
        } else if (bundleHandle) {
          pendingBundleSwap = true;
          galleryFetching = true;
          fetch('/products/' + bundleHandle)
            .then(function (r) {
              return r.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var bg = doc.querySelector('media-gallery');
              if (bg) bundleGalleryNode = document.adoptNode(bg);
              galleryFetching = false;
              if (pendingBundleSwap) {
                pendingBundleSwap = false;
                var ch = selector.querySelector('input[type="radio"][value="bundle"]');
                if (ch && ch.checked) doGallerySwap();
              }
            })
            .catch(function () {
              galleryFetching = false;
              pendingBundleSwap = false;
            });
        }
      } else if (mode === 'regular' && isBundleGallery) {
        pendingBundleSwap = false;
        if (originalGalleryNode) {
          var g = root.querySelector('media-gallery');
          if (g) {
            g.replaceWith(originalGalleryNode);
            isBundleGallery = false;
          }
        }
      }
    }

    function switchTo(mode) {
      if (mode === 'bundle') {
        if (buyBlock && !isFlyParent) buyBlock.style.display = 'none';
        if (!bundleWrap) bundleWrap = createBundleUI();
        bundleWrap.style.display = '';
        if (!isQuickBuy) {
          if (!stickyBundleUI.desktop && !stickyBundleUI.mobile) createStickyBundleUI();
          if (stickyDesktopForm) stickyDesktopForm.style.display = 'none';
          if (stickyMobileForm) stickyMobileForm.style.display = 'none';
          if (stickyBundleUI.desktop) stickyBundleUI.desktop.wrap.style.display = '';
          if (stickyBundleUI.mobile) stickyBundleUI.mobile.wrap.style.display = '';
        }
        refreshQtyUI();
        if (isQuickBuy) {
          setModalProductPriceHidden(true);
          ensureQvPriceRow();
        }
        if (!isFlyParent) {
          if (!isQuickBuy) updatePrice(prices.bundle);
          swapGallery('bundle');
          if (titleEl && bundleTitle) titleEl.textContent = bundleTitle;
          root.querySelectorAll('input[data-linked-main-variant-input]').forEach(function (radio) {
            radio.checked = false;
            radio.dataset.currentChecked = 'false';
          });
        }
      } else {
        if (buyBlock) buyBlock.style.display = '';
        if (bundleWrap) bundleWrap.style.display = 'none';
        if (!isQuickBuy) {
          if (stickyDesktopForm) stickyDesktopForm.style.display = '';
          if (stickyMobileForm) stickyMobileForm.style.display = '';
          if (stickyBundleUI.desktop) stickyBundleUI.desktop.wrap.style.display = 'none';
          if (stickyBundleUI.mobile) stickyBundleUI.mobile.wrap.style.display = 'none';
        }
        if (isQuickBuy) {
          hideQvPriceRow();
          setModalProductPriceHidden(false);
        }
        updatePrice(prices.regular);
        swapGallery('regular');
        if (titleEl && regularTitle) titleEl.textContent = regularTitle;
        var currentId = root.querySelector('[data-linked-main-variants]')
          ? root.querySelector('[data-linked-main-variants]').dataset.currentProductId
          : undefined;
        root.querySelectorAll('input[data-linked-main-variant-input]').forEach(function (radio) {
          var isCurrent = currentId && String(radio.dataset.productId) === String(currentId);
          radio.checked = !!isCurrent;
          radio.dataset.currentChecked = isCurrent ? 'true' : 'false';
        });
      }
    }

    selector.__sbSwitchTo = switchTo;

    function selectLabel(label, e) {
      if (e && e.cancelable) e.preventDefault();
      var radio = label.querySelector('input[type="radio"]');
      if (!radio || radio.checked) return;
      radio.checked = true;
      switchTo(radio.value);
    }

    var labels = selector.querySelectorAll('.variant-option__button-label');
    for (var i = 0; i < labels.length; i++) {
      (function (label) {
        var startX = 0;
        var startY = 0;
        label.addEventListener('pointerdown', function (e) {
          startX = e.clientX;
          startY = e.clientY;
        });
        label.addEventListener('pointerup', function (e) {
          if (Math.abs(e.clientX - startX) > 10 || Math.abs(e.clientY - startY) > 10) return;
          selectLabel(label, e);
        });
        label.addEventListener('click', function (e) {
          selectLabel(label, e);
        });
      })(labels[i]);
    }

    if (isFlyParent) {
      switchTo('bundle');
    }

    syncBundleStateFromCart();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.superbundle-selector').forEach(initSelector);
  }

  /**
   * Quick Buy remount: drop stale listeners/wrappers, then bind a fresh instance.
   * Never call this on the live PDP node — PDP uses initAll() once.
   */
  function initIn(root) {
    if (!root) return;
    root.querySelectorAll('.superbundle-atc-wrapper').forEach(function (el) {
      el.remove();
    });
    root.querySelectorAll('.superbundle-selector').forEach(function (selector) {
      var clone = selector.cloneNode(true);
      clone.removeAttribute('data-sb-inited');
      selector.replaceWith(clone);
      initSelector(clone);
    });
  }

  window.PWSuperbundle = {
    initSelector: initSelector,
    initAll: initAll,
    initIn: initIn
  };

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
